import Component from '../core/Component'
import GoogleMap from './GoogleMap'
import InfoBox from './InfoBox'

const cache = {}

export const STATUS = {
    EXPANDED: 'is-expanded'
}

export default class LunchMap extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            toggles: [],
            map: null
        }

        this.infoWindow = new InfoBox({
            componentClassName: 'lunch-InfoBox'
        })

        this.element.appendChild(this.infoWindow.element)
    }

    prepare() {
        this.ref.toggles.forEach(element => element.addEventListener('click', ::this.handleToggle))
        this.map = new GoogleMap(this.ref.map)
        this.map.onMarkerClick(::this.handleMarkerClick)
    }

    handleToggle(event) {
        event.preventDefault()

        this.element.classList.toggle(STATUS.EXPANDED)
        this.map.resize()
    }

    handleMarkerClick(marker) {
        this.showInfoWindow(marker)
    }

    showInfoWindow(marker) {
        this.infoWindowId = marker.options.data.id;

        if (marker.options.data.id in cache) {
            this.openInfoWindow(marker);
            return;
        }

        $.ajax({
            url: this.element.dataset.url,
            data: {
                id: marker.options.data.id
            },
            method: 'GET',
            dataType: 'HTML'
        }).then(response => {
            cache[marker.options.data.id] = response;

            if (this.infoWindowId === marker.options.data.id) {
                this.openInfoWindow(marker);
            }
        })
    }

    openInfoWindow(marker) {
        const map = this.map.map

        const projection = map.getProjection()
        const bounds = map.getBounds()

        const topRight = projection.fromLatLngToPoint(bounds.getNorthEast())
        const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest())

        const scale = Math.pow(2, map.getZoom());
        const worldPoint = projection.fromLatLngToPoint(marker.getPosition());
        const [x, y] = [Math.floor((worldPoint.x - bottomLeft.x) * scale), Math.floor((worldPoint.y - topRight.y) * scale)];

        this.infoWindow.open({x, y}, cache[marker.options.data.id])
    }

}